const CONVERSATION_ACCESS_DENIED_PATTERNS = [
  /conversation view operation denied/i,
  /not allowed to view this resource/i,
  /permission to view this resource/i,
];

function getErrorMessages(error: unknown): string[] {
  const messages: string[] = [];

  if (typeof error === "string") {
    messages.push(error);
    return messages;
  }

  if (error instanceof Error) {
    messages.push(error.message);
  }

  if (error && typeof error === "object" && "message" in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === "string") {
      messages.push(message);
    }
  }

  if (error && typeof error === "object" && "response" in error) {
    const response = (error as { response?: { data?: { error?: unknown; message?: unknown } } }).response;
    const responseError = response?.data?.error;
    const responseMessage = response?.data?.message;

    if (typeof responseError === "string") {
      messages.push(responseError);
    }

    if (typeof responseMessage === "string") {
      messages.push(responseMessage);
    }
  }

  return messages;
}

export function isConversationAccessDeniedError(error: unknown): boolean {
  const errorMessages = getErrorMessages(error);

  return errorMessages.some((errorMessage) =>
    CONVERSATION_ACCESS_DENIED_PATTERNS.some((pattern) => pattern.test(errorMessage)),
  );
}
